module.exports = __webpack_public_path__ + "img/admin.e7c8a417.svg";